import { Injectable } from '@angular/core';

export type UserRole = 'ADMIN' | 'ORGANIZATION' | 'INSTRUCTOR' | 'AFFILIATOR';

export interface LoggedInUser {
  userId: string;
  role: UserRole;
  name: string;
  email: string;
}

interface DemoAccount extends LoggedInUser {
  password: string;
  token: string;
  aliases?: string[];
}

@Injectable({ providedIn: 'root' })
export class RoleAuthService {
  private readonly accounts: DemoAccount[] = [
    { userId: 'admin', password: 'Admin@123', role: 'ADMIN', name: 'Admin', email: 'admin@iconma.com', token: 'hardcoded-admin-token' },
    { userId: 'organization', password: 'Organization@123', role: 'ORGANIZATION', name: 'Organization', email: 'organization@iconma.com', token: 'hardcoded-organization-token' },
    { userId: 'instructor', password: 'Instructor@123', role: 'INSTRUCTOR', name: 'Instructor', email: 'instructor@iconma.com', token: 'hardcoded-instructor-token' },
    { userId: 'affiliator', password: 'Affiliator@123', role: 'AFFILIATOR', name: 'Affiliator', email: 'affiliator@iconma.com', token: 'hardcoded-affiliator-token', aliases: ['affliator'] }
  ];

  login(userId: string, password: string): LoggedInUser | null {
    const normalizedUserId = userId.trim().toLowerCase();
    const account = this.accounts.find(item => (item.userId.toLowerCase() === normalizedUserId || item.aliases?.includes(normalizedUserId)) && item.password === password);
    if (!account) return null;

    const user: LoggedInUser = { userId: account.userId, role: account.role, name: account.name, email: account.email };
    localStorage.setItem('accessToken', account.token);
    localStorage.setItem('loggedInUser', JSON.stringify(user));
    return user;
  }

  logout(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('loggedInUser');
  }

  getCurrentUser(): LoggedInUser | null {
    const storedUser = localStorage.getItem('loggedInUser');
    if (!storedUser) return null;

    try {
      return JSON.parse(storedUser) as LoggedInUser;
    } catch {
      this.logout();
      return null;
    }
  }

  getDashboardRoute(role: UserRole): string {
    const routes: Record<UserRole, string> = {
      ADMIN: '/admin/dashboard',
      ORGANIZATION: '/organization/dashboard',
      INSTRUCTOR: '/instructor/dashboard',
      AFFILIATOR: '/affiliator/dashboard'
    };
    return routes[role];
  }
}
